import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DataTables from 'material-ui-datatables';
import IconButton from 'material-ui/IconButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FontIcon from 'material-ui/FontIcon';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FlatButton from 'material-ui/FlatButton';

import { fetchRolesRoutine, saveRoleRoutine, removeRoleRoutine } from '../../routines';
import { showDialog, hideDialog, isDialogOpen } from '../../actions/dialogs';
import Dashboard from '../Dashboard';
import RoleDialog from '../RoleDialog';
import { toArray, sortStrings, contains, getOrderDirection } from '../../utils/helper';
import Loading from '../Common/Loading';

import styles from './styles';

const getTableColumns = (onEdit, onRemove) => {
  return [
    {
      key: 'name',
      label: 'Role',
      render: (name) => name,
      sortable: true,
      style: styles.nameCol,
    }, {
      key: 'action',
      label: '',
      render: (a, role) => {
        return (<span><IconButton
          tooltip="Edit"
          tooltipPosition="bottom-center"
          onClick={() => onEdit(role)}
        >
          <FontIcon
            className="material-icons"
            style={styles.icon}
          >edit</FontIcon>
        </IconButton>
          <IconButton
            tooltip="Remove"
            tooltipPosition="bottom-center"
            onClick={() => onRemove(role)}
          >
            <FontIcon
              className="material-icons"
              style={styles.icon}
            >delete</FontIcon>
          </IconButton>
          </span>);
      },
      alignRight: true,
      style: styles.actionCol,
    },
  ];
};

const getSorter = (sorter = (a, b) => 0, order = 'asc') => {
  return (a, b) => {
    let result = sorter(a, b) * getOrderDirection(order);

    if (result === 0) {
      result = sortStrings(a.name, b.name);
    }

    return result;
  };
};

const getFilter = (filter) => {
  return (role) => {
    if (filter) {
      if (role.name && contains(role.name, filter)) {
        return true;
      }

      return false;
    }

    return true;
  };
};

class Roles extends Component {
  static propTypes = {
    fetchRoles: PropTypes.func.isRequired,
    saveRole: PropTypes.func.isRequired,
    removeRole: PropTypes.func.isRequired,
    roles: PropTypes.array.isRequired,

    loading: PropTypes.bool,
    dialogs: PropTypes.object.isRequired,
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
  };

  state = {
    selectedRows: [],
    page: 1,
    limit: 10,
    sortBy: getSorter((a, b) => sortStrings(a.name, b.name), 'asc'),
    order: 'asc',
    data: [],
  };

  componentWillMount() {
    this.props.fetchRoles();

    this.setState({
      data: this.props.roles.sort(this.state.sortBy),
    });
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      data: nextProps.roles.sort(this.state.sortBy),
    });
  };

  handleFilterValueChange = (filter) => {
    const { roles } = this.props;
    const { page, limit, sortBy } = this.state;

    const data = roles.filter(getFilter(filter ? filter.trim().toLowerCase() : '')).sort(sortBy);
    this.setState({
      page: Math.min(page, Math.floor(data.length / limit) + 1),
      data,
    });
  };

  handleSortOrderChange = (key, order) => {
    let sortBy = getSorter();
    switch (key) {
      case 'name':
        sortBy = getSorter((a, b) => sortStrings(a.name, b.name), order);
        break;
      default:
        break;
    }

    this.setState({
      data: this.state.data.sort(sortBy),
      sortBy,
    });
  };

  handlePreviousPageClick = () => {
    this.setState({
      page: Math.max(1, this.state.page - 1),
    });
  };

  handleNextPageClick = () => {
    const { data, page, limit } = this.state;

    this.setState({
      page: Math.min(Math.ceil(data.length / limit), page + 1),
    });
  };

  handleRowSizeChange = (a, limit) => {
    this.setState({
      limit,
      page: 1,
    });
  };

  handleEditRole = (role) => {
    console.log('editrole', role);
    this.props.showDialog('role', { role });
  };

  handleRemoveRole = (role) => {
    const context = {
      type: 'warning',
      title: 'Remove Jobs?',
      message: 'Are you sure you wish to remove this role?',
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => {
            this.props.hideDialog('confirm');
            this.props.removeRole(role);
          }}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  handleSaveRole = (role) => {
    if (role) {
      this.props.saveRole(role);
    }

    this.props.hideDialog('role');
  };
  // renderRole(role) {
  //   return (<TableRow key={role.id}>
  //     <TableRowColumn>{role.name}</TableRowColumn>
  //     <TableRowColumn style={styles.actionCol}>
  //       <IconButton tooltip="Remove" tooltipPosition="bottom-center" onClick={this.handleRemoveRole}>
  //         <ActionRemove />
  //       </IconButton>
  //     </TableRowColumn>
  //   </TableRow>);
  // }

  renderNoData() {
    return (<div style={styles.noDataRow}>
      <FontIcon className="material-icons" style={styles.noData}>lock_outline</FontIcon>
      <div>No roles are available</div>
    </div>);
  }

  render() {
    const { loading, dialogs } = this.props;
    const { page, limit, data } = this.state;

    return (
      <Dashboard title="Roles">
        {/*<Table multiSelectable={false} selectable={false}>*/}
        {/*<TableHeader adjustForCheckbox={false} displaySelectAll={false}>*/}
        {/*<TableRow>*/}
        {/*<TableHeaderColumn>Role</TableHeaderColumn>*/}
        {/*<TableHeaderColumn style={styles.actionCol}></TableHeaderColumn>*/}
        {/*</TableRow>*/}
        {/*</TableHeader>*/}
        {/*<TableBody displayRowCheckbox={false}>*/}
        {/*{ roles.length > 0 ? roles.map((role) => this.renderRole(role)) : this.renderNoData() }*/}
        {/*</TableBody>*/}
        {/*</Table>*/}

        { !loading ? <DataTables
          height={'auto'}
          showRowHover
          columns={getTableColumns(this.handleEditRole, this.handleRemoveRole)}
          data={data.slice((page - 1) * limit, page * limit)}
          onFilterValueChange={this.handleFilterValueChange}
          onSortOrderChange={this.handleSortOrderChange}
          onPreviousPageClick={this.handlePreviousPageClick}
          onNextPageClick={this.handleNextPageClick}
          onRowSizeChange={this.handleRowSizeChange}
          onRowSelection={this.handleRowSelection}
          page={page}
          rowSize={limit}
          rowSizeList={[10, 15, 25, 50, 100]}
          count={data.length}
          filterHintText="Filter"
          headerToolbarMode="filter"
          showHeaderToolbar
        /> : <Loading/> }

        <FloatingActionButton
          style={styles.addItem}
          onClick={() => this.props.showDialog('role', { role: {} })}
          secondary>
          <ContentAdd />
        </FloatingActionButton>

        { isDialogOpen(this.props.dialogs, 'role') ?
          <RoleDialog role={dialogs.role.context.role} onRequestClose={this.handleSaveRole}/> : null }
      </Dashboard>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchRoles: fetchRolesRoutine.trigger,
    saveRole: saveRoleRoutine.trigger,
    removeRole: removeRoleRoutine.trigger,
    showDialog,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    roles: toArray(state.get('roles').get('roles').toJS()).filter((role) => !role.deleted),
    loading: state.get('roles').get('loading'),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Roles);



// WEBPACK FOOTER //
// ./src/components/Roles/index.js